import React, { Component } from 'react';
import styled from 'styled-components';
import IconClose from '../atoms/assets/icons/IconClose';

const Holder = styled.div`
  display: block;
  background-color: ${props => props.theme.colours.lightGrey2};
  &.hide { display: none; }
  .icon-only {
  	position: absolute;
  	right: 0;
  }
`;

const HolderInner = styled.div`
	padding: 1.5rem 2rem 2.5rem;
	> *:first-child {
		margin-top: 0;
	}
	> *:last-child {
		margin-bottom: 0;
	}
`;

class AlertMessage extends Component {
		state = {
			messageVisible: 'show',
		};

		handleClose = () => {
			this.setState({
				messageVisible: 'hide',
			})
		};

    render() {
        return (
            <Holder className={this.state.messageVisible}>
            	<button className="icon-only" onClick={this.handleClose}><IconClose /></button>
            	<HolderInner>
            		{this.props.children}
          		</HolderInner>
            </Holder>
        )
    }
}

export default AlertMessage;
